class YdFooter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    // 处理 Order 按钮点击事件
    const orderBtn = this.querySelector('.sa-footer__order-btn');
    if (orderBtn) {
      orderBtn.addEventListener('click', () => {
        const orderAction = orderBtn.getAttribute('data-order-action');
        
        // 如果有自定义 action，执行它
        if (orderAction) {
          try {
            // 使用 Function 构造函数来执行用户提供的 JavaScript 代码
            new Function(orderAction)();
          } catch (error) {
            console.error('Error executing order action:', error);
          }
        } else {
          // 默认行为：打开 order dialog（使用全局方法）
          if (window.openOrderDialog && typeof window.openOrderDialog === 'function') {
            window.openOrderDialog({
              title: 'Talk to our team',
              description: 'Connect with our sales team to explore how our cutting-edge technology can empower your research today.',
              privacyUrl: '/pages/policy',
              termsUrl: '/pages/terms-of-use'
            });
          }
        }
      });
    }

    // 处理社交媒体链接的 hover 效果
    // 当 hover 一个链接时，其他链接变暗（添加 .on 类）
    const socialLinks = this.querySelectorAll('.sa-footer__social-link');
    socialLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        // 给其他链接添加 .on 类（变暗）
        socialLinks.forEach(otherLink => {
          if (otherLink !== link) {
            otherLink.classList.add('on');
          }
        });
      });
      
      link.addEventListener('mouseleave', () => {
        // 移除所有链接的 .on 类
        socialLinks.forEach(otherLink => {
          otherLink.classList.remove('on');
        });
      });
    });

  }
}

customElements.define('sa-footer', YdFooter);
